const normalizeSearchValue = (value) =>
  String(value ?? '').trim().replace(/\s+/g, ' ').toLocaleLowerCase('es-CO');

export const getTopSearchMatchIds = (items, query, fields, limit = 2) => {
  const normalizedQuery = normalizeSearchValue(query);
  if (!normalizedQuery || !Array.isArray(items)) return [];

  return items
    .map((item, originalIndex) => {
      let bestScore = Number.POSITIVE_INFINITY;
      const exactId = normalizeSearchValue(item?.id) === normalizedQuery;
      fields.forEach((field, fieldIndex) => {
        const value = normalizeSearchValue(
          typeof field === 'function' ? field(item) : item?.[field]
        );
        if (!value) return;
        const matchRank = value === normalizedQuery
          ? 0
          : value.startsWith(normalizedQuery)
            ? 1
            : value.includes(normalizedQuery)
              ? 2
              : Number.POSITIVE_INFINITY;
        bestScore = Math.min(bestScore, matchRank * 100 + fieldIndex);
      });
      return { id: item?.id, exactId, bestScore, originalIndex };
    })
    .filter(({ id, bestScore }) => id !== undefined && Number.isFinite(bestScore))
    .sort((left, right) =>
      Number(right.exactId) - Number(left.exactId)
      || left.bestScore - right.bestScore
      || left.originalIndex - right.originalIndex
    )
    .slice(0, limit)
    .map(({ id }) => id);
};
